[
  {
    "id": "setsubun_single_discounted",
    "currency": "gems",
    "price": 250,
    "ref_price": 1000,
    "tags": ["setsubun", "single", "discount"],
    "num_spins": 1,
    "buckets": {
      "setsubun_decoration_tier1": 2890,
      "setsubun_decoration_tier2": 990,
      "setsubun_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "setsubun_single",
    "currency": "gems",
    "price": 1000,
    "tags": ["setsubun", "single"],
    "num_spins": 1,
    "buckets": {
      "setsubun_decoration_tier1": 2890,
      "setsubun_decoration_tier2": 990,
      "setsubun_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "setsubun_10_discounted",
    "currency": "gems",
    "price": 9000,
    "ref_price": 10000,
    "tags": ["setsubun", "10-spin", "discount"],
    "num_spins": 10,
    "buckets": {
      "setsubun_decoration_tier1": 2890,
      "setsubun_decoration_tier2": 990,
      "setsubun_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "setsubun_10",
    "currency": "gems",
    "price": 10000,
    "tags": ["setsubun", "10-spin"],
    "num_spins": 10,
    "buckets": {
      "setsubun_decoration_tier1": 2890,
      "setsubun_decoration_tier2": 990,
      "setsubun_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "valentines_single",
    "currency": "gems",
    "price": 1000,
    "tags": ["valentines", "single"],
    "num_spins": 1,
    "buckets": {
      "e0001_valentine_tier1": 169,
      "e0001_valentine_tier2": 56,
      "e0001_valentine_tier3": 19,
      "e0001_valentine_tier4": 6,
      "regular_decoration_tier1": 519,
      "regular_decoration_tier2": 173,
      "regular_decoration_tier3": 58
    }
  },
  {
    "id": "valentines_single_discounted",
    "currency": "gems",
    "price": 250,
    "ref_price": 1000,
    "tags": ["valentines", "single", "discount"],
    "num_spins": 1,
    "buckets": {
      "e0001_valentine_tier1": 169,
      "e0001_valentine_tier2": 56,
      "e0001_valentine_tier3": 19,
      "e0001_valentine_tier4": 6,
      "regular_decoration_tier1": 519,
      "regular_decoration_tier2": 173,
      "regular_decoration_tier3": 58
    }
  },
  {
    "id": "valentines_10",
    "currency": "gems",
    "price": 10000,
    "tags": ["valentines", "10-spin"],
    "num_spins": 10,
    "buckets": {
      "e0001_valentine_tier1": 169,
      "e0001_valentine_tier2": 56,
      "e0001_valentine_tier3": 19,
      "e0001_valentine_tier4": 6,
      "regular_decoration_tier1": 519,
      "regular_decoration_tier2": 173,
      "regular_decoration_tier3": 58
    }
  },
  {
    "id": "valentines_10_discounted",
    "currency": "gems",
    "price": 9000,
    "ref_price": 10000,
    "tags": ["valentines", "10-spin", "discount"],
    "num_spins": 10,
    "buckets": {
      "e0001_valentine_tier1": 169,
      "e0001_valentine_tier2": 56,
      "e0001_valentine_tier3": 19,
      "e0001_valentine_tier4": 6,
      "regular_decoration_tier1": 519,
      "regular_decoration_tier2": 173,
      "regular_decoration_tier3": 58
    }
  },
  {
    "id": "cafe_single_discounted",
    "currency": "gems",
    "price": 250,
    "ref_price": 1000,
    "tags": ["cafe", "single", "discount"],
    "num_spins": 1,
    "buckets": {
      "cafe_decoration_tier1": 2890,
      "cafe_decoration_tier2": 990,
      "cafe_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "cafe_single",
    "currency": "gems",
    "price": 1000,
    "tags": ["cafe", "single"],
    "num_spins": 1,
    "buckets": {
      "cafe_decoration_tier1": 2890,
      "cafe_decoration_tier2": 990,
      "cafe_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "cafe_10_discounted",
    "currency": "gems",
    "price": 9000,
    "ref_price": 10000,
    "tags": ["cafe", "10-spin", "discount"],
    "num_spins": 10,
    "buckets": {
      "cafe_decoration_tier1": 2890,
      "cafe_decoration_tier2": 990,
      "cafe_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "cafe_10",
    "currency": "gems",
    "price": 10000,
    "tags": ["cafe", "10-spin"],
    "num_spins": 10,
    "buckets": {
      "cafe_decoration_tier1": 2890,
      "cafe_decoration_tier2": 990,
      "cafe_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "hanami_single_discounted",
    "currency": "gems",
    "price": 250,
    "ref_price": 1000,
    "tags": ["hanami", "single", "discount"],
    "num_spins": 1,
    "buckets": {
      "hanami_decoration_tier1": 2890,
      "hanami_decoration_tier2": 990,
      "hanami_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "hanami_single",
    "currency": "gems",
    "price": 1000,
    "tags": ["hanami", "single"],
    "num_spins": 1,
    "buckets": {
      "hanami_decoration_tier1": 2890,
      "hanami_decoration_tier2": 990,
      "hanami_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "hanami_10_discounted",
    "currency": "gems",
    "price": 9000,
    "ref_price": 10000,
    "tags": ["hanami", "10-spin", "discount"],
    "num_spins": 10,
    "buckets": {
      "hanami_decoration_tier1": 2890,
      "hanami_decoration_tier2": 990,
      "hanami_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "hanami_10",
    "currency": "gems",
    "price": 10000,
    "tags": ["hanami", "10-spin"],
    "num_spins": 10,
    "buckets": {
      "hanami_decoration_tier1": 2890,
      "hanami_decoration_tier2": 990,
      "hanami_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "childrens_day2025_single_discounted",
    "currency": "gems",
    "price": 250,
    "ref_price": 1000,
    "tags": ["childrens_day2025", "single", "discount"],
    "num_spins": 1,
    "buckets": {
      "childrens_day2025_decoration_tier1": 2890,
      "childrens_day2025_decoration_tier2": 990,
      "childrens_day2025_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "childrens_day2025_single",
    "currency": "gems",
    "price": 1000,
    "tags": ["childrens_day2025", "single"],
    "num_spins": 1,
    "buckets": {
      "childrens_day2025_decoration_tier1": 2890,
      "childrens_day2025_decoration_tier2": 990,
      "childrens_day2025_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "childrens_day2025_10_discounted",
    "currency": "gems",
    "price": 9000,
    "ref_price": 10000,
    "tags": ["childrens_day2025", "10-spin", "discount"],
    "num_spins": 10,
    "buckets": {
      "childrens_day2025_decoration_tier1": 2890,
      "childrens_day2025_decoration_tier2": 990,
      "childrens_day2025_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "childrens_day2025_10",
    "currency": "gems",
    "price": 10000,
    "tags": ["childrens_day2025", "10-spin"],
    "num_spins": 10,
    "buckets": {
      "childrens_day2025_decoration_tier1": 2890,
      "childrens_day2025_decoration_tier2": 990,
      "childrens_day2025_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "mothers_day2025_single_discounted",
    "currency": "gems",
    "price": 250,
    "ref_price": 1000,
    "tags": ["mothers_day2025", "single", "discount"],
    "num_spins": 1,
    "buckets": {
      "mothers_day2025_decoration_tier1": 2890,
      "mothers_day2025_decoration_tier2": 990,
      "mothers_day2025_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "mothers_day2025_single",
    "currency": "gems",
    "price": 1000,
    "tags": ["mothers_day2025", "single"],
    "num_spins": 1,
    "buckets": {
      "mothers_day2025_decoration_tier1": 2890,
      "mothers_day2025_decoration_tier2": 990,
      "mothers_day2025_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "mothers_day2025_10_discounted",
    "currency": "gems",
    "price": 9000,
    "ref_price": 10000,
    "tags": ["mothers_day2025", "10-spin", "discount"],
    "num_spins": 10,
    "buckets": {
      "mothers_day2025_decoration_tier1": 2890,
      "mothers_day2025_decoration_tier2": 990,
      "mothers_day2025_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "mothers_day2025_10",
    "currency": "gems",
    "price": 10000,
    "tags": ["mothers_day2025", "10-spin"],
    "num_spins": 10,
    "buckets": {
      "mothers_day2025_decoration_tier1": 2890,
      "mothers_day2025_decoration_tier2": 990,
      "mothers_day2025_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "melon_season_single_discounted",
    "currency": "gems",
    "price": 250,
    "ref_price": 1000,
    "tags": ["melon_season", "single", "discount"],
    "num_spins": 1,
    "buckets": {
      "melon_season_decoration_tier1": 2890,
      "melon_season_decoration_tier2": 990,
      "melon_season_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "melon_season_single",
    "currency": "gems",
    "price": 1000,
    "tags": ["melon_season", "single"],
    "num_spins": 1,
    "buckets": {
      "melon_season_decoration_tier1": 2890,
      "melon_season_decoration_tier2": 990,
      "melon_season_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "melon_season_10_discounted",
    "currency": "gems",
    "price": 9000,
    "ref_price": 10000,
    "tags": ["melon_season", "10-spin", "discount"],
    "num_spins": 10,
    "buckets": {
      "melon_season_decoration_tier1": 2890,
      "melon_season_decoration_tier2": 990,
      "melon_season_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "melon_season_10",
    "currency": "gems",
    "price": 10000,
    "tags": ["melon_season", "10-spin"],
    "num_spins": 10,
    "buckets": {
      "melon_season_decoration_tier1": 2890,
      "melon_season_decoration_tier2": 990,
      "melon_season_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "tanabata_single_discounted",
    "currency": "gems",
    "price": 250,
    "ref_price": 1000,
    "tags": ["tanabata", "single", "discount"],
    "num_spins": 1,
    "buckets": {
      "tanabata_decoration_tier1": 2890,
      "tanabata_decoration_tier2": 990,
      "tanabata_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "tanabata_single",
    "currency": "gems",
    "price": 1000,
    "tags": ["tanabata", "single"],
    "num_spins": 1,
    "buckets": {
      "tanabata_decoration_tier1": 2890,
      "tanabata_decoration_tier2": 990,
      "tanabata_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "tanabata_10_discounted",
    "currency": "gems",
    "price": 9000,
    "ref_price": 10000,
    "tags": ["tanabata", "10-spin", "discount"],
    "num_spins": 10,
    "buckets": {
      "tanabata_decoration_tier1": 2890,
      "tanabata_decoration_tier2": 990,
      "tanabata_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "tanabata_10",
    "currency": "gems",
    "price": 10000,
    "tags": ["tanabata", "10-spin"],
    "num_spins": 10,
    "buckets": {
      "tanabata_decoration_tier1": 2890,
      "tanabata_decoration_tier2": 990,
      "tanabata_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "kakigori_single_discounted",
    "currency": "gems",
    "price": 250,
    "ref_price": 1000,
    "tags": ["kakigori", "single", "discount"],
    "num_spins": 1,
    "buckets": {
      "kakigori_decoration_tier1": 2890,
      "kakigori_decoration_tier2": 990,
      "kakigori_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "kakigori_single",
    "currency": "gems",
    "price": 1000,
    "tags": ["kakigori", "single"],
    "num_spins": 1,
    "buckets": {
      "kakigori_decoration_tier1": 2890,
      "kakigori_decoration_tier2": 990,
      "kakigori_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "kakigori_10_discounted",
    "currency": "gems",
    "price": 9000,
    "ref_price": 10000,
    "tags": ["kakigori", "10-spin", "discount"],
    "num_spins": 10,
    "buckets": {
      "kakigori_decoration_tier1": 2890,
      "kakigori_decoration_tier2": 990,
      "kakigori_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "kakigori_10",
    "currency": "gems",
    "price": 10000,
    "tags": ["kakigori", "10-spin"],
    "num_spins": 10,
    "buckets": {
      "kakigori_decoration_tier1": 2890,
      "kakigori_decoration_tier2": 990,
      "kakigori_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "moonviewing2025_single_discounted",
    "currency": "gems",
    "price": 250,
    "ref_price": 1000,
    "tags": ["moonviewing2025", "single", "discount"],
    "num_spins": 1,
    "buckets": {
      "moonviewing2025_decoration_tier1": 2890,
      "moonviewing2025_decoration_tier2": 990,
      "moonviewing2025_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "moonviewing2025_single",
    "currency": "gems",
    "price": 1000,
    "tags": ["moonviewing2025", "single"],
    "num_spins": 1,
    "buckets": {
      "moonviewing2025_decoration_tier1": 2890,
      "moonviewing2025_decoration_tier2": 990,
      "moonviewing2025_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "moonviewing2025_10_discounted",
    "currency": "gems",
    "price": 9000,
    "ref_price": 10000,
    "tags": ["moonviewing2025", "10-spin", "discount"],
    "num_spins": 10,
    "buckets": {
      "moonviewing2025_decoration_tier1": 2890,
      "moonviewing2025_decoration_tier2": 990,
      "moonviewing2025_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "moonviewing2025_10",
    "currency": "gems",
    "price": 10000,
    "tags": ["moonviewing2025", "10-spin"],
    "num_spins": 10,
    "buckets": {
      "moonviewing2025_decoration_tier1": 2890,
      "moonviewing2025_decoration_tier2": 990,
      "moonviewing2025_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "magicalbooks_single_discounted",
    "currency": "gems",
    "price": 250,
    "ref_price": 1000,
    "tags": ["magicalbooks", "single", "discount"],
    "num_spins": 1,
    "buckets": {
      "magicalbooks_decoration_tier1": 2890,
      "magicalbooks_decoration_tier2": 990,
      "magicalbooks_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "magicalbooks_single",
    "currency": "gems",
    "price": 1000,
    "tags": ["magicalbooks", "single"],
    "num_spins": 1,
    "buckets": {
      "magicalbooks_decoration_tier1": 2890,
      "magicalbooks_decoration_tier2": 990,
      "magicalbooks_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "magicalbooks_10_discounted",
    "currency": "gems",
    "price": 9000,
    "ref_price": 10000,
    "tags": ["magicalbooks", "10-spin", "discount"],
    "num_spins": 10,
    "buckets": {
      "magicalbooks_decoration_tier1": 2890,
      "magicalbooks_decoration_tier2": 990,
      "magicalbooks_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "magicalbooks_10",
    "currency": "gems",
    "price": 10000,
    "tags": ["magicalbooks", "10-spin"],
    "num_spins": 10,
    "buckets": {
      "magicalbooks_decoration_tier1": 2890,
      "magicalbooks_decoration_tier2": 990,
      "magicalbooks_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "taste_autumn_single_discounted",
    "currency": "gems",
    "price": 250,
    "ref_price": 1000,
    "tags": ["taste_autumn", "single", "discount"],
    "num_spins": 1,
    "buckets": {
      "taste_autumn_decoration_tier1": 2890,
      "taste_autumn_decoration_tier2": 990,
      "taste_autumn_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "taste_autumn_single",
    "currency": "gems",
    "price": 1000,
    "tags": ["taste_autumn", "single"],
    "num_spins": 1,
    "buckets": {
      "taste_autumn_decoration_tier1": 2890,
      "taste_autumn_decoration_tier2": 990,
      "taste_autumn_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "taste_autumn_10_discounted",
    "currency": "gems",
    "price": 9000,
    "ref_price": 10000,
    "tags": ["taste_autumn", "10-spin", "discount"],
    "num_spins": 10,
    "buckets": {
      "taste_autumn_decoration_tier1": 2890,
      "taste_autumn_decoration_tier2": 990,
      "taste_autumn_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "taste_autumn_10",
    "currency": "gems",
    "price": 10000,
    "tags": ["taste_autumn", "10-spin"],
    "num_spins": 10,
    "buckets": {
      "taste_autumn_decoration_tier1": 2890,
      "taste_autumn_decoration_tier2": 990,
      "taste_autumn_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "winter_candle_single_discounted",
    "currency": "gems",
    "price": 250,
    "ref_price": 1000,
    "tags": ["winter_candle", "single", "discount"],
    "num_spins": 1,
    "buckets": {
      "winter_candle_decoration_tier1": 2890,
      "winter_candle_decoration_tier2": 990,
      "winter_candle_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "winter_candle_single",
    "currency": "gems",
    "price": 1000,
    "tags": ["winter_candle", "single"],
    "num_spins": 1,
    "buckets": {
      "winter_candle_decoration_tier1": 2890,
      "winter_candle_decoration_tier2": 990,
      "winter_candle_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "winter_candle_10_discounted",
    "currency": "gems",
    "price": 9000,
    "ref_price": 10000,
    "tags": ["winter_candle", "10-spin", "discount"],
    "num_spins": 10,
    "buckets": {
      "winter_candle_decoration_tier1": 2890,
      "winter_candle_decoration_tier2": 990,
      "winter_candle_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "winter_candle_10",
    "currency": "gems",
    "price": 10000,
    "tags": ["winter_candle", "10-spin"],
    "num_spins": 10,
    "buckets": {
      "winter_candle_decoration_tier1": 2890,
      "winter_candle_decoration_tier2": 990,
      "winter_candle_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "ice_queens_castle_single_discounted",
    "currency": "gems",
    "price": 250,
    "ref_price": 1000,
    "tags": ["ice_queens_castle", "single", "discount"],
    "num_spins": 1,
    "buckets": {
      "ice_queens_castle_decoration_tier1": 2890,
      "ice_queens_castle_decoration_tier2": 990,
      "ice_queens_castle_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "ice_queens_castle_single",
    "currency": "gems",
    "price": 1000,
    "tags": ["ice_queens_castle", "single"],
    "num_spins": 1,
    "buckets": {
      "ice_queens_castle_decoration_tier1": 2890,
      "ice_queens_castle_decoration_tier2": 990,
      "ice_queens_castle_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "ice_queens_castle_10_discounted",
    "currency": "gems",
    "price": 9000,
    "ref_price": 10000,
    "tags": ["ice_queens_castle", "10-spin", "discount"],
    "num_spins": 10,
    "buckets": {
      "ice_queens_castle_decoration_tier1": 2890,
      "ice_queens_castle_decoration_tier2": 990,
      "ice_queens_castle_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "ice_queens_castle_10",
    "currency": "gems",
    "price": 10000,
    "tags": ["ice_queens_castle", "10-spin"],
    "num_spins": 10,
    "buckets": {
      "ice_queens_castle_decoration_tier1": 2890,
      "ice_queens_castle_decoration_tier2": 990,
      "ice_queens_castle_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "artisan_chocolatier_single_discounted",
    "currency": "gems",
    "price": 250,
    "ref_price": 1000,
    "tags": ["artisan_chocolatier", "single", "discount"],
    "num_spins": 1,
    "buckets": {
      "artisan_chocolatier_decoration_tier1": 2890,
      "artisan_chocolatier_decoration_tier2": 990,
      "artisan_chocolatier_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "artisan_chocolatier_single",
    "currency": "gems",
    "price": 1000,
    "tags": ["artisan_chocolatier", "single"],
    "num_spins": 1,
    "buckets": {
      "artisan_chocolatier_decoration_tier1": 2890,
      "artisan_chocolatier_decoration_tier2": 990,
      "artisan_chocolatier_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "artisan_chocolatier_10_discounted",
    "currency": "gems",
    "price": 9000,
    "ref_price": 10000,
    "tags": ["artisan_chocolatier", "10-spin", "discount"],
    "num_spins": 10,
    "buckets": {
      "artisan_chocolatier_decoration_tier1": 2890,
      "artisan_chocolatier_decoration_tier2": 990,
      "artisan_chocolatier_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "artisan_chocolatier_10",
    "currency": "gems",
    "price": 10000,
    "tags": ["artisan_chocolatier", "10-spin"],
    "num_spins": 10,
    "buckets": {
      "artisan_chocolatier_decoration_tier1": 2890,
      "artisan_chocolatier_decoration_tier2": 990,
      "artisan_chocolatier_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "valentine_day_single_discounted",
    "currency": "gems",
    "price": 250,
    "ref_price": 1000,
    "tags": ["valentine_day", "single", "discount"],
    "num_spins": 1,
    "buckets": {
      "valentine_day_decoration_tier1": 2890,
      "valentine_day_decoration_tier2": 990,
      "valentine_day_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "valentine_day_single",
    "currency": "gems",
    "price": 1000,
    "tags": ["valentine_day", "single"],
    "num_spins": 1,
    "buckets": {
      "valentine_day_decoration_tier1": 2890,
      "valentine_day_decoration_tier2": 990,
      "valentine_day_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "valentine_day_10_discounted",
    "currency": "gems",
    "price": 9000,
    "ref_price": 10000,
    "tags": ["valentine_day", "10-spin", "discount"],
    "num_spins": 10,
    "buckets": {
      "valentine_day_decoration_tier1": 2890,
      "valentine_day_decoration_tier2": 990,
      "valentine_day_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "valentine_day_10",
    "currency": "gems",
    "price": 10000,
    "tags": ["valentine_day", "10-spin"],
    "num_spins": 10,
    "buckets": {
      "valentine_day_decoration_tier1": 2890,
      "valentine_day_decoration_tier2": 990,
      "valentine_day_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "spring_tea_party_single_discounted",
    "currency": "gems",
    "price": 250,
    "ref_price": 1000,
    "tags": ["spring_tea_party", "single", "discount"],
    "num_spins": 1,
    "buckets": {
      "spring_tea_party_decoration_tier1": 2890,
      "spring_tea_party_decoration_tier2": 990,
      "spring_tea_party_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "spring_tea_party_single",
    "currency": "gems",
    "price": 1000,
    "tags": ["spring_tea_party", "single"],
    "num_spins": 1,
    "buckets": {
      "spring_tea_party_decoration_tier1": 2890,
      "spring_tea_party_decoration_tier2": 990,
      "spring_tea_party_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "spring_tea_party_10_discounted",
    "currency": "gems",
    "price": 9000,
    "ref_price": 10000,
    "tags": ["spring_tea_party", "10-spin", "discount"],
    "num_spins": 10,
    "buckets": {
      "spring_tea_party_decoration_tier1": 2890,
      "spring_tea_party_decoration_tier2": 990,
      "spring_tea_party_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "spring_tea_party_10",
    "currency": "gems",
    "price": 10000,
    "tags": ["spring_tea_party", "10-spin"],
    "num_spins": 10,
    "buckets": {
      "spring_tea_party_decoration_tier1": 2890,
      "spring_tea_party_decoration_tier2": 990,
      "spring_tea_party_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "easter_egg_hunt_single_discounted",
    "currency": "gems",
    "price": 250,
    "ref_price": 1000,
    "tags": ["easter_egg_hunt", "single", "discount"],
    "num_spins": 1,
    "buckets": {
      "easter_egg_hunt_decoration_tier1": 2890,
      "easter_egg_hunt_decoration_tier2": 990,
      "easter_egg_hunt_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "easter_egg_hunt_single",
    "currency": "gems",
    "price": 1000,
    "tags": ["easter_egg_hunt", "single"],
    "num_spins": 1,
    "buckets": {
      "easter_egg_hunt_decoration_tier1": 2890,
      "easter_egg_hunt_decoration_tier2": 990,
      "easter_egg_hunt_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "easter_egg_hunt_10_discounted",
    "currency": "gems",
    "price": 9000,
    "ref_price": 10000,
    "tags": ["easter_egg_hunt", "10-spin", "discount"],
    "num_spins": 10,
    "buckets": {
      "easter_egg_hunt_decoration_tier1": 2890,
      "easter_egg_hunt_decoration_tier2": 990,
      "easter_egg_hunt_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "easter_egg_hunt_10",
    "currency": "gems",
    "price": 10000,
    "tags": ["easter_egg_hunt", "10-spin"],
    "num_spins": 10,
    "buckets": {
      "easter_egg_hunt_decoration_tier1": 2890,
      "easter_egg_hunt_decoration_tier2": 990,
      "easter_egg_hunt_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "golden_week_single_discounted",
    "currency": "gems",
    "price": 250,
    "ref_price": 1000,
    "tags": ["golden_week", "single", "discount"],
    "num_spins": 1,
    "buckets": {
      "golden_week_decoration_tier1": 2890,
      "golden_week_decoration_tier2": 990,
      "golden_week_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "golden_week_single",
    "currency": "gems",
    "price": 1000,
    "tags": ["golden_week", "single"],
    "num_spins": 1,
    "buckets": {
      "golden_week_decoration_tier1": 2890,
      "golden_week_decoration_tier2": 990,
      "golden_week_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "golden_week_10_discounted",
    "currency": "gems",
    "price": 9000,
    "ref_price": 10000,
    "tags": ["golden_week", "10-spin", "discount"],
    "num_spins": 10,
    "buckets": {
      "golden_week_decoration_tier1": 2890,
      "golden_week_decoration_tier2": 990,
      "golden_week_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "golden_week_10",
    "currency": "gems",
    "price": 10000,
    "tags": ["golden_week", "10-spin"],
    "num_spins": 10,
    "buckets": {
      "golden_week_decoration_tier1": 2890,
      "golden_week_decoration_tier2": 990,
      "golden_week_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "rainyseason_bookcafe_single_discounted",
    "currency": "gems",
    "price": 250,
    "ref_price": 1000,
    "tags": ["rainyseason_bookcafe", "single", "discount"],
    "num_spins": 1,
    "buckets": {
      "rainyseason_bookcafe_decoration_tier1": 2890,
      "rainyseason_bookcafe_decoration_tier2": 990,
      "rainyseason_bookcafe_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "rainyseason_bookcafe_single",
    "currency": "gems",
    "price": 1000,
    "tags": ["rainyseason_bookcafe", "single"],
    "num_spins": 1,
    "buckets": {
      "rainyseason_bookcafe_decoration_tier1": 2890,
      "rainyseason_bookcafe_decoration_tier2": 990,
      "rainyseason_bookcafe_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "rainyseason_bookcafe_10_discounted",
    "currency": "gems",
    "price": 9000,
    "ref_price": 10000,
    "tags": ["rainyseason_bookcafe", "10-spin", "discount"],
    "num_spins": 10,
    "buckets": {
      "rainyseason_bookcafe_decoration_tier1": 2890,
      "rainyseason_bookcafe_decoration_tier2": 990,
      "rainyseason_bookcafe_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "rainyseason_bookcafe_10",
    "currency": "gems",
    "price": 10000,
    "tags": ["rainyseason_bookcafe", "10-spin"],
    "num_spins": 10,
    "buckets": {
      "rainyseason_bookcafe_decoration_tier1": 2890,
      "rainyseason_bookcafe_decoration_tier2": 990,
      "rainyseason_bookcafe_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "tropical_island_vacation_single_discounted",
    "currency": "gems",
    "price": 250,
    "ref_price": 1000,
    "tags": ["tropical_island_vacation", "single", "discount"],
    "num_spins": 1,
    "buckets": {
      "tropical_island_vacation_decoration_tier1": 2890,
      "tropical_island_vacation_decoration_tier2": 990,
      "tropical_island_vacation_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "tropical_island_vacation_single",
    "currency": "gems",
    "price": 1000,
    "tags": ["tropical_island_vacation", "single"],
    "num_spins": 1,
    "buckets": {
      "tropical_island_vacation_decoration_tier1": 2890,
      "tropical_island_vacation_decoration_tier2": 990,
      "tropical_island_vacation_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "tropical_island_vacation_10_discounted",
    "currency": "gems",
    "price": 9000,
    "ref_price": 10000,
    "tags": ["tropical_island_vacation", "10-spin", "discount"],
    "num_spins": 10,
    "buckets": {
      "tropical_island_vacation_decoration_tier1": 2890,
      "tropical_island_vacation_decoration_tier2": 990,
      "tropical_island_vacation_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "tropical_island_vacation_10",
    "currency": "gems",
    "price": 10000,
    "tags": ["tropical_island_vacation", "10-spin"],
    "num_spins": 10,
    "buckets": {
      "tropical_island_vacation_decoration_tier1": 2890,
      "tropical_island_vacation_decoration_tier2": 990,
      "tropical_island_vacation_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "seashell_single_discounted",
    "currency": "gems",
    "price": 250,
    "ref_price": 1000,
    "tags": ["seashell", "single", "discount"],
    "num_spins": 1,
    "buckets": {
      "seashell_decoration_tier1": 2890,
      "seashell_decoration_tier2": 990,
      "seashell_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "seashell_single",
    "currency": "gems",
    "price": 1000,
    "tags": ["seashell", "single"],
    "num_spins": 1,
    "buckets": {
      "seashell_decoration_tier1": 2890,
      "seashell_decoration_tier2": 990,
      "seashell_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "seashell_10_discounted",
    "currency": "gems",
    "price": 9000,
    "ref_price": 10000,
    "tags": ["seashell", "10-spin", "discount"],
    "num_spins": 10,
    "buckets": {
      "seashell_decoration_tier1": 2890,
      "seashell_decoration_tier2": 990,
      "seashell_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "seashell_10",
    "currency": "gems",
    "price": 10000,
    "tags": ["seashell", "10-spin"],
    "num_spins": 10,
    "buckets": {
      "seashell_decoration_tier1": 2890,
      "seashell_decoration_tier2": 990,
      "seashell_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "early_autumn_picnic_single_discounted",
    "currency": "gems",
    "price": 250,
    "ref_price": 1000,
    "tags": ["early_autumn_picnic", "single", "discount"],
    "num_spins": 1,
    "buckets": {
      "early_autumn_picnic_decoration_tier1": 2890,
      "early_autumn_picnic_decoration_tier2": 990,
      "early_autumn_picnic_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "early_autumn_picnic_single",
    "currency": "gems",
    "price": 1000,
    "tags": ["early_autumn_picnic", "single"],
    "num_spins": 1,
    "buckets": {
      "early_autumn_picnic_decoration_tier1": 2890,
      "early_autumn_picnic_decoration_tier2": 990,
      "early_autumn_picnic_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "early_autumn_picnic_10_discounted",
    "currency": "gems",
    "price": 9000,
    "ref_price": 10000,
    "tags": ["early_autumn_picnic", "10-spin", "discount"],
    "num_spins": 10,
    "buckets": {
      "early_autumn_picnic_decoration_tier1": 2890,
      "early_autumn_picnic_decoration_tier2": 990,
      "early_autumn_picnic_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "early_autumn_picnic_10",
    "currency": "gems",
    "price": 10000,
    "tags": ["early_autumn_picnic", "10-spin"],
    "num_spins": 10,
    "buckets": {
      "early_autumn_picnic_decoration_tier1": 2890,
      "early_autumn_picnic_decoration_tier2": 990,
      "early_autumn_picnic_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "pumpkin_farm_single_discounted",
    "currency": "gems",
    "price": 250,
    "ref_price": 1000,
    "tags": ["pumpkin_farm", "single", "discount"],
    "num_spins": 1,
    "buckets": {
      "pumpkin_farm_decoration_tier1": 2890,
      "pumpkin_farm_decoration_tier2": 990,
      "pumpkin_farm_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "pumpkin_farm_single",
    "currency": "gems",
    "price": 1000,
    "tags": ["pumpkin_farm", "single"],
    "num_spins": 1,
    "buckets": {
      "pumpkin_farm_decoration_tier1": 2890,
      "pumpkin_farm_decoration_tier2": 990,
      "pumpkin_farm_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "pumpkin_farm_10_discounted",
    "currency": "gems",
    "price": 9000,
    "ref_price": 10000,
    "tags": ["pumpkin_farm", "10-spin", "discount"],
    "num_spins": 10,
    "buckets": {
      "pumpkin_farm_decoration_tier1": 2890,
      "pumpkin_farm_decoration_tier2": 990,
      "pumpkin_farm_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  },
  {
    "id": "pumpkin_farm_10",
    "currency": "gems",
    "price": 10000,
    "tags": ["pumpkin_farm", "10-spin"],
    "num_spins": 10,
    "buckets": {
      "pumpkin_farm_decoration_tier1": 2890,
      "pumpkin_farm_decoration_tier2": 990,
      "pumpkin_farm_decoration_tier3": 100,
      "regular_decoration_tier1": 4162,
      "regular_decoration_tier2": 1396,
      "regular_decoration_tier3": 462
    }
  }
]
